const { IMAGE_BASE_URL } = require("@/assets/js/config")
export const getImageURL = (filename) => {
    return `${IMAGE_BASE_URL}${filename}`
}

export const getImageObjectFromURL = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = (err) => reject(err);
        img.src = url;
    });
}